<div [class.bl-disabled]="!field.enabled">
  <label [class.bl-screen-reader-only]="screenReaderOnly(field)" class="bl-label bl-font-weight--800 bl-font-size--14" [for]="field.id" [class.bl-required]="field.required" [id]="field.id + '-label'">
    {{ field.label }}
    <ng-container *ngIf="field.config.tooltip">
      <button
        type="button"
        aria-label="tooltip"
        attr.aria-describedby="tooltip-info-{{ field.id }}"
        class="bl-font-color--blue bl-margin-left--4"
      >
        <i class="cu-info-circle" eaTooltip="{{ field.config.tooltip }}"></i>
      </button>
      <span id="tooltip-info-{{ field.id }}" class="bl-screen-reader-only">{{ field.config.tooltip }}</span>
    </ng-container>
  </label>
  <div class="bl-select-wrap">
    <select
      [required]="field.required"
      class="bl-select bl-input"
      [attr.aria-describedby]="field.id + '-desc-container'"
      [attr.aria-labelledby]="fieldLabelledBy"
      [attr.data-automation-id]="field.automationId"
      [disabled]="!field.enabled"
      [cuFieldState]="field"
      [id]="field.id"
      [(ngModel)]="field.data.value"
    >
      <option *ngIf="showDefault" [value]="null" disabled selected>{{ 'customDropdown/selectOne' | dictionary }}</option>
      <option *ngFor="let item of field.enum" [value]="item.value" [selected]="field.data.value == item.value">{{ item.label }}</option>
    </select>
  </div>
</div>
